import Paper from '@material-ui/core/Paper';
import React, { useReducer, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import OPCUATree from '../components/OPCUATree';

const OPCUATreePageComponent = (props) => {
	return (
		<div
			style={{
				maxHeight: '100%',
				padding: '24px',
				overflow: 'auto',
				boxSizing: 'border-box'
			}}
		>
			<Paper
				style={{
					padding: '32px',
					maxWidth: '960px',
					margin: 'auto',
					position: 'relative'
				}}
			>
				<OPCUATree />
			</Paper>
		</div>
	);
};

OPCUATreePageComponent.propTypes = {
};

const mapDispatchToProps = {
};

const mapStateToProps = (state) => ({
});

export const OPCUATreePage = connect(
	mapStateToProps,
	mapDispatchToProps
)(OPCUATreePageComponent);



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/opcua-webui-components/src/pages/OPCUATreePage.js